import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { SenecButton } from "@newsenec/ui-components";
import { SenecScreenTemplate } from "../SenecScreenTemplate";
import { isAppControl, logout } from "@newsenec/auth-provider";

export const UnauthorizedScreen = () => {
    const { t } = useTranslation();

    const application = isAppControl() ? "SENEC.Control" : "SENEC.Cockpit";

    return (
        <SenecScreenTemplate
            data-testid={"login-unauthorized-screen"}
            title={t("unauthorizedScreen.title")}
            content={
                <Typography sx={{ whiteSpace: "pre-line", textAlignLast: "center" }}>
                    {t("unauthorizedScreen.description", { application: application })}
                </Typography>
            }
            footer={
                <Box>
                    <SenecButton
                        level="primary"
                        onClick={() => {
                            void logout();
                        }}
                    >
                        {t("unauthorizedScreen.logoutButton")}
                    </SenecButton>
                </Box>
            }
        />
    );
};
